// react-rails gem で行っていた処理から必要な部分を切り出している
// https://github.com/reactjs/react-rails/blob/67d724e3effdf2dbc9c241339c515f034f917d22/react_ujs/index.js

// Rails 側で設定される属性名
const COMPONENT_NAME_ATTR = 'data-react-component';
const PROPS_ATTR = 'data-react-props';

// COMPONENT_NAME_ATTR を持つ要素を取得し、対応する React コンポーネントを動的にレンダリングする
const renderComponents = () => {
  const nodes = document.querySelectorAll(`[${COMPONENT_NAME_ATTR}]`);

  nodes.forEach((node) => {
    // 該当するコンポーネントを取得
    const componentName = node.getAttribute(COMPONENT_NAME_ATTR);
    const component = window[componentName];
    if (!component) {
      throw new Error(`Unable to find component for ${componentName}.`);
    }

    // Rails 側から渡された props を取得
    const propsJson = node.getAttribute(PROPS_ATTR);
    const props = propsJson && JSON.parse(propsJson);

    const reactElement = React.createElement(component, props);
    ReactDOM.createRoot(node).render(reactElement);
  });
};

const mountOnLoad = () => {
  document.addEventListener('DOMContentLoaded', () => {
    // app/views/shared/_include_react.html.erb で React が読み込まれている場合
    if (typeof React !== 'undefined' && typeof ReactDOM !== 'undefined') {
      renderComponents();
    }
  });
};

mountOnLoad();
